import {useAuctionSettings} from "hooks/StateHooks"
import React from "react"
import {fetchIndicators} from "redux/actions"
import LoadingIndicator from "../../components/LoadingIndicator"
import AuctionedVehiclesStatistic from "../../components/Statistic/Cards/AuctionedVehiclesStatistic"
import ClaimedVehiclesStatistic from "../../components/Statistic/Cards/ClaimedVehiclesStatistic"
import HighestBidderCountStatistic from "../../components/Statistic/Cards/HighestBidderCountStatistic"
import HighestBidMaxStatistic from "../../components/Statistic/Cards/HighestBidMaxStatistic"
import HighestBidStatistic from "../../components/Statistic/Cards/HighestBidStatistic"
import StatisticContainer from "../../components/Statistic/StatisticContainer"
import AppNavigation from "../AppNavigation"
import {connect} from "react-redux"
import {GlobalState} from "../../state"
import {IndicatorsState} from "../../redux/reducers/IndicatorReducer"


type DashboardProps = {
  budget: number
  indicators: IndicatorsState
  isInternalHandler: boolean
}

type DashboardState = {
  busy: boolean
}

class Dashboard extends React.Component<DashboardProps, DashboardState> {
  constructor(props: DashboardProps) {
    super(props)
    this.state = {
      busy: false,
    }
  }

  componentDidMount = async () => {
    this.setState({
      busy: true
    })
    await fetchIndicators()
    this.setState({
      busy: false
    })
  }

  renderInternalHandlerDashboard() {
    return (
      <StatisticContainer>
        <ClaimedVehiclesStatistic />
      </StatisticContainer>
    )
  }

  renderExternalDealerDashboard() {
    const settings = useAuctionSettings()
    return (
      <StatisticContainer>
        {
          settings && settings.dashboard && settings.dashboard.showSumHighestBids &&
          <HighestBidStatistic sumBids={this.props.indicators.sumBids} bidLimit={this.props.budget}/>
        }

        {
          settings && settings.dashboard && settings.dashboard.showSumMaxBids &&
          <HighestBidMaxStatistic sumMaxBids={this.props.indicators.sumMaxBids} bidLimit={this.props.budget} sumBids={this.props.indicators.sumBids}/>
        }

        {
          settings && settings.dashboard && settings.dashboard.showHighestBidderCount &&
          <HighestBidderCountStatistic highestBidder={this.props.indicators.highestBidder}/>
        }

        {
          settings && settings.dashboard && settings.dashboard.showAuctionedCount &&
          <AuctionedVehiclesStatistic/>
        }
      </StatisticContainer>
    )
  }

  render() {
    return (
      <div className="block sm:flex h-full sm:h-auto overflow-y-auto">
        <div className="hidden lg:block">
          <AppNavigation/>
        </div>

        <div className="w-full h-full">
          {this.state.busy ?
            <LoadingIndicator/>
            :
            this.props.isInternalHandler 
              ? this.renderInternalHandlerDashboard()
              : this.renderExternalDealerDashboard()
          }
        </div>
      </div>
    )
  }
}

export default connect((state: GlobalState) => ({
  budget: state.user.app_settings ? state.user.app_settings.budget : 0,
  indicators: state.indicators,
  isInternalHandler: !!(window as any)?.app?.user?.authority?.mod_speed_auction_claim
}))(Dashboard)
